var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.72871 5.31435C8.31451 5.90016 8.31451 6.84993 7.72871 7.43574C7.1429 8.02154 6.19313 8.02154 5.60732 7.43574C5.02152 6.84993 5.02152 5.90016 5.60732 5.31435C6.19313 4.72855 7.1429 4.72855 7.72871 5.31435Z",
    fill: "#664EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1682 2.25005H10.1318L9.38138 0.75H3.95433L3.20466 2.25079L2.16971 2.25263C1.34462 2.25411 0.672954 2.92649 0.672242 3.75195L0.668213 9.74992C0.668213 10.5772 1.34096 11.2503 2.16827 11.2503H11.1682C11.9955 11.2503 12.6682 10.5776 12.6682 9.75029V3.75008C12.6682 2.9228 11.9955 2.25005 11.1682 2.25005ZM6.66803 9.37527C5.01379 9.37527 3.66792 8.0294 3.66792 6.37516C3.66792 4.72093 5.01379 3.37506 6.66803 3.37506C8.32227 3.37506 9.66813 4.72093 9.66813 6.37516C9.66813 8.0294 8.32227 9.37527 6.66803 9.37527Z",
    fill: "#664EF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.668213)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e5f4152567c4f647caa300d9035e3944.svg";
export { ForwardRef as ReactComponent };